import React from 'react';
import './contact.css';
const Contact = () => {
  const handleClick = () => {
    window.location.href = 'mailto:virajchoubey.workspace@gmail.com';
  };

  return (
    <div>
      <h1>Contact</h1>
      <p>I would love to hear from you!</p>
      <p>For any inquiries or feedback, please click on the button below to send me an email:</p>
      <button onClick={handleClick}>Write to us</button>
    </div>
  );
};

export default Contact;

